import App from './App.js';

let app = new App();
app.init(); 


// WEBPACK FOOTER //
// ./src/js/index.js